import './ceTextEditor.less';

import React from 'react';
import { observer } from 'mobx-react';
import { EditOutlined } from '@ant-design/icons';
import AceEditor from 'react-ace';
import 'vendor-init/ace-editor';
import { AntTextArea } from 'controls/react/ant/antInput';
import { AntFlex } from 'controls/react/ant/antFlex';
import { AntButton } from 'controls/react/ant/antButton';
import { FieldWrapper } from './fieldWrapper';
import { FormBuilderContext } from '../formBuilderContext';
import { Property } from '../models';
import { translator } from 'core/localization/localization';
import b_ from 'b_';
import { FormBuilderStore } from '../formBuilderStore';
import { makeAutoObservable } from 'mobx';
import { useStore } from 'core/react/useStore';
import { ModalDescription, openModal } from 'controls/react/ant/antModal';
import { Section } from 'controls/react/layout/section';

const b = b_.with('ce-text-editor');

const i18n = translator({
	'Edit / View': {
		no: 'Rediger / Vis',
	},
});

class CETextEditorStore {
	text: string;
	modal: ModalDescription;
	constructor(
		public formStore: FormBuilderStore,
		public property: Property,
	) {
		makeAutoObservable(this);
	}

	get disabled() {
		return this.formStore.propertyDisabled(this.property);
	}

	destroy() {}

	setText = (text: string) => {
		this.text = text;
	};

	openEditor = () => {
		this.text = this.formStore.value[this.property.id] as string;
		this.modal = openModal(
			{
				title: this.property.caption,
				onOk: this.save,
				mode: 'update',
				width: 600,
				height: 500,
			},
			<Section>
				<AceEditor
					value={this.text}
					onChange={this.setText}
					mode={this.property.language ?? 'groovy'}
					theme={'crimson_editor'}
					height={'100%'}
					width={'100%'}
					focus
				/>
			</Section>,
		);
	};

	save = () => {
		this.formStore.onPropertyValueChange(this.property, this.text);
		this.modal.close();
	};
}

export const CETextEditor = observer(({ property }: { property: Property }) => {
	const formStore = React.useContext(FormBuilderContext);
	const store = useStore(() => new CETextEditorStore(formStore, property));

	return (
		<AntFlex gap="10px" align="stretch">
			<FieldWrapper property={property} className={b('input')}>
				<AntTextArea readOnly autoSize={{ minRows: 1, maxRows: 3 }} onClick={store.openEditor} />
			</FieldWrapper>
			<AntButton
				disabled={store.disabled}
				title={i18n('Edit / View')}
				onClick={store.openEditor}
				className={b('button')}
			>
				<EditOutlined />
			</AntButton>
		</AntFlex>
	);
});

export default CETextEditor;
